<template>
  <div class="vis-screens-malfunction-notification ba-shadow-xl">
    <div class="vis-screens-malfunction-notification__wrapper">
      <div class="vis-screens-malfunction-notification__text">
        Уважаемый пользователь, некоторые ваши запросы могут исполняться с задержкой в связи с техническими работами в смежных системах.
      </div>

     <a
        class="vis-screens-malfunction-notification__button"
        @click="closeDialog"
      >Понятно</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'vis-screens-malfunction-notification',

  methods: {
    closeDialog() {
      this.$emit('closeNotification')
    },
  }
}
</script>

<style lang="scss">
.vis-screens-malfunction-notification {
  position: fixed;
  z-index: 9999;
  top: 0;
  right: 0;
  left: 0;
  background-color: #ffffff;
  padding: 16px;

  &__wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: nowrap;
    width: 100%;
    max-width: 1280px;
    margin: 0 auto;
  }

  & &__button,
  & &__button:visited {
    flex: 0 0 auto;
    padding: 8px 16px;
    margin-left: 20px;
    color: white !important;
    cursor: pointer;
    background-color: #4a93ff;
    border-radius: 9999px;
  }

  & &__button:hover {
    color: white !important;
    background-color: lighten(#4a93ff, 10%);
    text-decoration: none;
  }
}
</style>
